// extracted by mini-css-extract-plugin
module.exports = {"container":"CarrelloScommesse_container__Xa7Uu","button":"CarrelloScommesse_button__0JnKR"};